import __vue_normalize__ from 'vue-runtime-helpers/dist/normalize-component.mjs';

/* script */

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"1em","height":"1em","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M18 3H6V7H18V3Z","fill":"currentColor"}}),_vm._v(" "),_c('path',{attrs:{"d":"M15 17H9V18H15V17Z","fill":"currentColor"}}),_vm._v(" "),_c('path',{attrs:{"d":"M15 15H9V16H15V15Z","fill":"currentColor"}}),_vm._v(" "),_c('path',{attrs:{"d":"M21 10.86C21 10.1015 20.6987 9.37403 20.1623 8.83767C19.626 8.30132 18.8985 8 18.14 8H5.86C5.10148 8 4.37403 8.30132 3.83767 8.83767C3.30132 9.37403 3 10.1015 3 10.86V17H6V21H18V17H21V10.86ZM16 19H8V14H16V19ZM18 12C17.8022 12 17.6089 11.9414 17.4444 11.8315C17.28 11.7216 17.1518 11.5654 17.0761 11.3827C17.0004 11.2 16.9806 10.9989 17.0192 10.8049C17.0578 10.6109 17.153 10.4327 17.2929 10.2929C17.4327 10.153 17.6109 10.0578 17.8049 10.0192C17.9989 9.98063 18.2 10.0004 18.3827 10.0761C18.5654 10.1518 18.7216 10.28 18.8315 10.4444C18.9414 10.6089 19 10.8022 19 11C19 11.2652 18.8946 11.5196 18.7071 11.7071C18.5196 11.8946 18.2652 12 18 12Z","fill":"currentColor"}})])};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    {},
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
